import { cn } from '@infinex/ui-styles';

export const ACCENT_GRADIENT =
  'radial-gradient(73.76% 121.46% at 13.87% -2.43%, rgba(254, 111, 57, 0.07) 0%, rgba(254, 111, 57, 0.00) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.00) 100%), transparent';

export const ACCENT_GRADIENT_SURFACE =
  'radial-gradient(73.76% 121.46% at 13.87% -2.43%, rgba(254, 111, 57, 0.07) 0%, rgba(254, 111, 57, 0.00) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.00) 100%), var(--colors-bg-surface-surface, #17191C)';

interface AccentGradientOverlayProps {
  className?: string;
}

/**
 * A decorative accent gradient overlay positioned absolutely within its parent.
 * Used to add subtle brand emphasis to cards and containers.
 *
 * @example
 * // With rounded corners matching parent container
 * <AccentGradientOverlay className="rounded-large" />
 */
export const AccentGradientOverlay = ({
  className,
}: AccentGradientOverlayProps) => (
  <div
    className={cn('pointer-events-none absolute inset-0', className)}
    style={{ background: ACCENT_GRADIENT }}
  />
);
